<script setup lang="ts">
import AppWrapper from "@/components/AppWrapper.vue";
import Appbar from "@/components/Appbar.vue";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import LeadReviewBanner from "@/components/leadBot/LeadReviewBanner.vue";
import LeadDemoRequestOverlay from "@/components/leadBot/LeadDemoRequestOverlay.vue";
import { useLeadRestriction } from "@/components/leadBot/leadRestriction";
import { computed, inject } from "vue";

const iframed = inject("iframed", false);
const { isRestricted, demoRequestOpen } = useLeadRestriction();
/** Same condition as in `LeadDemoRequestOverlay`: the page behind it is out of the keyboard's reach meanwhile */
const demoRequestShown = computed(() => isRestricted.value && demoRequestOpen.value);
defineProps<{paddedContent?: boolean}>();
</script>

<template>
  <AppWrapper v-if="!iframed" :padded-content :content-inert="demoRequestShown">
    <template #header>
      <Appbar>
        <template #left>
          <SidebarTrigger class="mx-1" />
          <Separator orientation="vertical" class="bg-white/20" />
        </template>
      </Appbar>
      <LeadReviewBanner />
    </template>

    <slot />

    <template #overlay>
      <LeadDemoRequestOverlay />
    </template>
  </AppWrapper>

  <main v-else class="h-full">
    <slot />
  </main>
</template>